module.exports = __webpack_public_path__ + "static/media/bar-chart.49680956.png";